export default __webpack_public_path__ + "static/media/WM0490.34I-43516_-26035_0.ca8f5094.jpg";